import { object, string } from "yup";

// ============================================================================
// Profile Step Schema (only step)
// ============================================================================

export const profileStepSchema = object({
  stageName: string().max(255, "Le nom de scène ne peut pas dépasser 255 caractères").defined(),
});

export type ProfileStepInputs = {
  stageName: string;
};
